bam-google-autocomplete {
  flex: 1;
}
